import { ModalCustom } from "components/ModalCustom";
import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Required } from "components/Required";
import { Controller, useForm } from "react-hook-form";
import temaPadrao from "_config/temas/estilo/base";
import { PrimaryButton } from "components/Button/style";
import { yupResolver } from "@hookform/resolvers/yup";
import { ContainerForm } from "./style";
import FileUpload from "components/UploadArquivos";
import { IConfirmarPagamento } from "../../../../interface/IConfirmarPagamento";
import { confirmarPagamentoSchema } from "../../../../validate/confirmarPagamentoSchema";
import { CustomDatePicker } from "components/DatePicker";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: (dados: IConfirmarPagamento) => void;
}

export function ModalConfirmarPagamento({
  show,
  handleClose,
  onSubmit,
}: Props) {
  const [dataPagamento, setDataPagamento] = useState<Date>(new Date());
  const onChangeDataPagamento = (date: any) => {
    setDataPagamento(date);
  };
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(confirmarPagamentoSchema),
  });

  useEffect(() => {
    const dataHoje = new Date();
    reset({
      dataPagamento: `${dataHoje}`,
      arquivo: "",
    });
    setValue("dataPagamento", `${dataHoje}`);
    setValue("arquivo", "");
    setDataPagamento(dataHoje);
  }, [show]);

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Confirmar pagamento"
      centered
    >
      <form
        onSubmit={handleSubmit((dados: IConfirmarPagamento) => {
          onSubmit(dados);
        })}
      >
        <ContainerForm>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Data do pagamento <Required />
                </Form.Label>
                <Controller
                  name="dataPagamento"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomDatePicker
                      selected={dataPagamento}
                      minDate={(() => {
                        let data = new Date();
                        let diasUteis = 0;

                        while (diasUteis < 2) {
                          data.setDate(data.getDate() - 1);
                          const diaSemana = data.getDay();
                          if (diaSemana !== 0 && diaSemana !== 6) {
                            diasUteis++;
                          }
                        }

                        return data;
                      })()}
                      mensagemErro={errors.dataPagamento?.message}
                      onChange={(update) => {
                        onChange(update);
                        onChangeDataPagamento(update);
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Comprovante de pagamento <Required />
                </Form.Label>
                <Controller
                  name="arquivo"
                  control={control}
                  render={({ field: { onChange } }) => (
                    <FileUpload
                      onFileUpload={(file) => {
                        onChange(file);
                      }}
                      mensagemErro={errors.arquivo?.message}
                      comMaxWidth={false}
                      inputAccept=""
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </ContainerForm>
        <div className="d-flex justify-content-end gap-4 mt-4">
          <PrimaryButton
            style={{ width: "10rem" }}
            outline
            variante="primary"
            onClick={handleClose}
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton style={{ width: "10rem" }} type="submit">
            Salvar
          </PrimaryButton>
        </div>
      </form>
    </ModalCustom>
  );
}
